import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = {
  class: "modal-content",
  style: {"height":"calc(100vh - 50px)"}
}
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "text-lowercase" }
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  class: "nav nav-tabs",
  role: "tablist"
}
const _hoisted_12 = { class: "nav-item" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "tab-content" }
const _hoisted_15 = {
  class: "alert alert-info alert-dismissible",
  role: "alert"
}
const _hoisted_16 = { class: "text-lowercase italic" }
const _hoisted_17 = { class: "text-lowercase italic" }
const _hoisted_18 = { class: "text-lowercase italic" }
const _hoisted_19 = { class: "text-lowercase italic" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "dropdown" }
const _hoisted_23 = {
  class: "btn btn-outline-secondary btn-lg btn-block",
  "data-toggle": "dropdown"
}
const _hoisted_24 = {
  class: "dropdown-menu",
  style: {"width":"100%","max-height":"250px","overflow-y":"auto"}
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "input-group input-group-lg" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "table table-bordered"
}
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "fa-solid fa-square-check"
}
const _hoisted_34 = {
  key: 1,
  class: "fa-regular fa-square"
}
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "d-flex justify-content-end" }
const _hoisted_37 = {
  key: 0,
  class: "dropdown ml-1"
}
const _hoisted_38 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["innerHTML"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "d-flex justify-content-end" }
const _hoisted_43 = { class: "dropdown" }
const _hoisted_44 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "dropdown ml-1"
}
const _hoisted_47 = {
  class: "dropdown-menu dropdown-menu-right",
  style: {"overflow-y":"auto","max-height":"400px"}
}
const _hoisted_48 = ["onClick"]
const _hoisted_49 = { class: "form-group" }

import { ref, computed } from 'vue'

    import { insertIntoTextArea1 } from '@common/Common'

    import type {
        ScoringAlternativeReadModel,
        ScoringAttributeReadModel,
        ScoringListReadModel,
        ScoringStatusReadModel
    } from '@Evaluation/AlternativesSurveys/Domain/readmodels'

    import
        {
            SurveyAlternativesManagerDialogSaveEventPayload,
            SurveyAlternativesManagerDialogViewModel
        } from '@Evaluation/AlternativesSurveys/Components/SurveyAlternativesManagerDialog'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyAlternativesManagerDialog',
  props: {
    viewModel: {}
  },
  emits: ["load-alternatives", "preview-description", "save-survey"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- shortcuts ---------------- */

    const vm = computed(() => props.viewModel)
    const opened = computed(() => vm.value?.opened ?? false)

    /* ---------------- derived (read-only) ---------------- */

    const initialized = computed(() => vm.value.initialized)
    const filtering = computed(() => vm.value.filtering)

    const alternativesLabel = computed(() => vm.value.alternativesLabel)
    const attributes = computed<ScoringAttributeReadModel[]>(() => vm.value.attributes)
    const statuses = computed<ScoringStatusReadModel[]>(() => vm.value.statuses)
    const lists = computed<ScoringListReadModel[]>(() => vm.value.lists)
    const filterLabel = computed(() => vm.value.filterLabel)

    const surveyId = computed(() => vm.value.surveyId)
    const surveyName = computed(() => vm.value.surveyName)

    const includedAlternatives = computed<ScoringAlternativeReadModel[]>(() => vm.value.includedAlternatives)
    const alternativesView = computed<ScoringAlternativeReadModel[]>(() => vm.value.alternativesView)
    const alternativeDescriptionPreview = computed(() => vm.value.alternativeDescriptionPreview)

    /* ---------------- writable computed (VM passthrough) ---------------- */

    const searchPhrase = computed<string | null>({
        get: () => vm.value.searchPhrase,
        set: val => { vm.value.searchPhrase = val }
    })

    const activeTab = computed<string>({
        get: () => vm.value.activeTab,
        set: val => { vm.value.activeTab = val }
    })

    const previewMode = computed<boolean>({
        get: () => vm.value.previewMode,
        set: val => { vm.value.previewMode = val }
    })

    const descriptionTemplate = computed<string | null>({
        get: () => vm.value.descriptionTemplate,
        set: val => { vm.value.descriptionTemplate = val }
    })

    /* ---------------- refs ---------------- */

    const descriptionTemplateTextArea = ref<HTMLTextAreaElement | null>(null)

    /* ---------------- helpers ---------------- */

    function insertIntoDescriptionTemplate(txt: string)
    {
        if (!descriptionTemplateTextArea.value) return

        insertIntoTextArea1(descriptionTemplateTextArea.value, `{${txt}}`)
        descriptionTemplateTextArea.value.dispatchEvent(new Event('input'))
    }

    function includeAll()
    {
        alternativesView.value.forEach(a => (a.IsIncluded = true))
    }

    function excludeAll()
    {
        alternativesView.value.forEach(a => (a.IsIncluded = false))
    }

    /* ---------------- filtering ---------------- */

    function clearFilter()
    {
        vm.value.clearFilter()
    }

    function filterIncluded()
    {
        vm.value.filterIncluded()
    }

    function filterExcluded()
    {
        vm.value.filterExcluded()
    }

    function filterByStatus(statusId: number, statusName: string)
    {
        vm.value.filterByStatus(statusId, statusName)
    }

    function filterByList(listId: string, listName: string)
    {
        vm.value.filterByList(listId, listName)
        emit('load-alternatives', listId)
    }

    /* ---------------- preview / save ---------------- */

    function showDescriptionPreview(alternativeId: string)
    {
        previewMode.value = true
        vm.value.alternativeDescriptionPreview = null
        emit('preview-description', alternativeId, descriptionTemplate.value)
    }

    function handleConfirm()
    {
        const payload = new SurveyAlternativesManagerDialogSaveEventPayload(
            surveyId.value,
            descriptionTemplate.value,
            includedAlternatives.value.map(a => a.AlternativeId)
        )

        emit('save-survey', payload)
    }

    /* ---------------- lifecycle ---------------- */

    function closeDialog()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, [
                  _cache[7] || (_cache[7] = _createTextVNode("Manage ", -1 /* CACHED */)),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(alternativesLabel.value), 1 /* TEXT */)
                ]),
                _createElementVNode("button", {
                  onClick: closeDialog,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_8, [
                (initialized.value === false)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_9, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("ul", _hoisted_11, [
                        _createElementVNode("li", _hoisted_12, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["nav-link", {'active': activeTab.value === 'Alternatives'}]),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'Alternatives'))
                          }, "Select", 2 /* CLASS */)
                        ]),
                        _createElementVNode("li", _hoisted_13, [
                          _createElementVNode("a", {
                            class: _normalizeClass(["nav-link", {'active': activeTab.value === 'Template'}]),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'Template'))
                          }, "Define description", 2 /* CLASS */)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", {
                          class: _normalizeClass([{'active': activeTab.value === 'Alternatives'}, "tab-pane pt-3"])
                        }, [
                          _createElementVNode("div", _hoisted_15, [
                            _cache[11] || (_cache[11] = _createElementVNode("button", {
                              type: "button",
                              class: "close",
                              "data-dismiss": "alert",
                              "aria-label": "Close"
                            }, [
                              _createElementVNode("span", { "aria-hidden": "true" }, "×")
                            ], -1 /* CACHED */)),
                            _cache[12] || (_cache[12] = _createTextVNode(" Select which ", -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_16, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                            _cache[13] || (_cache[13] = _createTextVNode(" are included in your panel. You can use the filter or search to find the ", -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_17, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                            _cache[14] || (_cache[14] = _createTextVNode(" you want to include, then check the ", -1 /* CACHED */)),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                            _cache[15] || (_cache[15] = _createTextVNode(" you want (one-by-one or in bulk using the gear-wheel). ", -1 /* CACHED */)),
                            _createElementVNode("strong", null, [
                              _cache[9] || (_cache[9] = _createTextVNode("WARNING: New ", -1 /* CACHED */)),
                              _createElementVNode("span", _hoisted_19, _toDisplayString(alternativesLabel.value), 1 /* TEXT */),
                              _cache[10] || (_cache[10] = _createTextVNode(" won't be included in panels automatically.", -1 /* CACHED */))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("a", _hoisted_23, [
                                  _createTextVNode(" Filter by: " + _toDisplayString(filterLabel.value ?? 'None') + " ", 1 /* TEXT */),
                                  _cache[16] || (_cache[16] = _createElementVNode("span", { class: "caret" }, null, -1 /* CACHED */))
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: clearFilter
                                  }, "No filter"),
                                  _cache[17] || (_cache[17] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: filterIncluded
                                  }, "Included in the survey"),
                                  _createElementVNode("a", {
                                    class: "dropdown-item",
                                    onClick: filterExcluded
                                  }, "Not included in the survey"),
                                  _cache[18] || (_cache[18] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _cache[19] || (_cache[19] = _createElementVNode("div", { class: "dropdown-header" }, "Filter by status:", -1 /* CACHED */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(statuses.value, (s) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      class: "dropdown-item",
                                      key: s.Id,
                                      onClick: ($event: any) => (filterByStatus(s.Id, s.Name))
                                    }, _toDisplayString(s.Name), 9 /* TEXT, PROPS */, _hoisted_25))
                                  }), 128 /* KEYED_FRAGMENT */)),
                                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dropdown-header" }, "Filter by list:", -1 /* CACHED */)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lists.value, (l) => {
                                    return (_openBlock(), _createElementBlock("a", {
                                      class: "dropdown-item",
                                      key: l.Id,
                                      onClick: ($event: any) => (filterByList(l.Id, l.Name))
                                    }, _toDisplayString(l.Name), 9 /* TEXT, PROPS */, _hoisted_26))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("div", _hoisted_28, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "search",
                                  placeholder: "Search...",
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchPhrase).value = $event))
                                }, null, 512 /* NEED_PATCH */), [
                                  [_vModelText, searchPhrase.value]
                                ]),
                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "input-group-append" }, [
                                  _createElementVNode("span", { class: "input-group-text" }, [
                                    _createElementVNode("i", {
                                      class: "fa-solid fa-magnifying-glass",
                                      "aria-hidden": "true"
                                    })
                                  ])
                                ], -1 /* CACHED */))
                              ])
                            ])
                          ]),
                          _cache[26] || (_cache[26] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                          (filtering.value === true)
                            ? (_openBlock(), _createElementBlock("h3", _hoisted_29, "Loading..."))
                            : _createCommentVNode("v-if", true),
                          (filtering.value === false)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_30, [
                                _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", {
                                      style: {"width":"45px"},
                                      class: "text-center"
                                    }, [
                                      _createElementVNode("div", { class: "dropdown" }, [
                                        _cache[23] || (_cache[23] = _createElementVNode("a", {
                                          class: "text-primary",
                                          "data-toggle": "dropdown"
                                        }, [
                                          _createElementVNode("i", { class: "fa fa-cog fa-lg" })
                                        ], -1 /* CACHED */)),
                                        _createElementVNode("div", { class: "dropdown-menu" }, [
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: includeAll
                                          }, "Include all listed below"),
                                          _createElementVNode("a", {
                                            class: "dropdown-item",
                                            onClick: excludeAll
                                          }, "Exclude all listed below")
                                        ])
                                      ])
                                    ]),
                                    _cache[24] || (_cache[24] = _createElementVNode("th", null, "Name", -1 /* CACHED */)),
                                    _cache[25] || (_cache[25] = _createElementVNode("th", null, "Status", -1 /* CACHED */))
                                  ])
                                ]),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alternativesView.value, (a) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: a.Id
                                    }, [
                                      _createElementVNode("td", _hoisted_31, [
                                        _createElementVNode("a", {
                                          class: "text-primary",
                                          onClick: ($event: any) => (a.IsIncluded = !a.IsIncluded)
                                        }, [
                                          (a.IsIncluded === true)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_33))
                                            : _createCommentVNode("v-if", true),
                                          (a.IsIncluded === false)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_34))
                                            : _createCommentVNode("v-if", true)
                                        ], 8 /* PROPS */, _hoisted_32)
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(a.Name), 1 /* TEXT */),
                                      _createElementVNode("td", null, _toDisplayString(a.StatusName), 1 /* TEXT */)
                                    ]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass([{'active': activeTab.value === 'Template' }, "tab-pane pt-3"])
                        }, [
                          (previewMode.value === true)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createElementVNode("div", _hoisted_36, [
                                  _createElementVNode("button", {
                                    class: "btn btn-sm btn-secondary",
                                    onClick: _cache[3] || (_cache[3] = ($event: any) => (previewMode.value = false))
                                  }, "Edit template"),
                                  (includedAlternatives.value?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _cache[27] || (_cache[27] = _createElementVNode("button", {
                                          class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                          "data-toggle": "dropdown"
                                        }, "Preview", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_38, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(includedAlternatives.value, (a) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                              class: "dropdown-item",
                                              key: a.Id,
                                              onClick: ($event: any) => (showDescriptionPreview(a.Id))
                                            }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_39))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", { innerHTML: alternativeDescriptionPreview.value }, null, 8 /* PROPS */, _hoisted_40)
                              ]))
                            : _createCommentVNode("v-if", true),
                          (previewMode.value === false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _cache[28] || (_cache[28] = _createElementVNode("button", {
                                      class: "btn btn-sm btn-secondary dropdown-toggle",
                                      "data-toggle": "dropdown"
                                    }, "Insert", -1 /* CACHED */)),
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[4] || (_cache[4] = ($event: any) => (insertIntoDescriptionTemplate('Description')))
                                      }, "Description"),
                                      _createElementVNode("a", {
                                        class: "dropdown-item",
                                        onClick: _cache[5] || (_cache[5] = ($event: any) => (insertIntoDescriptionTemplate('Status')))
                                      }, "Status"),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(attributes.value, (attr) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                          class: "dropdown-item",
                                          key: attr.Id,
                                          onClick: ($event: any) => (insertIntoDescriptionTemplate(attr.Name))
                                        }, _toDisplayString(attr.Name), 9 /* TEXT, PROPS */, _hoisted_45))
                                      }), 128 /* KEYED_FRAGMENT */))
                                    ])
                                  ]),
                                  (includedAlternatives.value?.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _cache[29] || (_cache[29] = _createElementVNode("button", {
                                          class: "btn btn-sm btn-outline-secondary dropdown-toggle",
                                          "data-toggle": "dropdown"
                                        }, "Preview", -1 /* CACHED */)),
                                        _createElementVNode("div", _hoisted_47, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(includedAlternatives.value, (a) => {
                                            return (_openBlock(), _createElementBlock("a", {
                                              class: "dropdown-item",
                                              key: a.Id,
                                              onClick: ($event: any) => (showDescriptionPreview(a.Id))
                                            }, _toDisplayString(a.Name), 9 /* TEXT, PROPS */, _hoisted_48))
                                          }), 128 /* KEYED_FRAGMENT */))
                                        ])
                                      ]))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("div", _hoisted_49, [
                                  _withDirectives(_createElementVNode("textarea", {
                                    ref_key: "descriptionTemplateTextArea",
                                    ref: descriptionTemplateTextArea,
                                    rows: "5",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((descriptionTemplate).value = $event)),
                                    class: "form-control"
                                  }, null, 512 /* NEED_PATCH */), [
                                    [_vModelText, descriptionTemplate.value]
                                  ]),
                                  _cache[30] || (_cache[30] = _createElementVNode("small", { class: "form-text text-muted" }, null, -1 /* CACHED */))
                                ])
                              ]))
                            : _createCommentVNode("v-if", true)
                        ], 2 /* CLASS */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: handleConfirm,
                  class: "btn btn-primary"
                }, "Save & Close"),
                _createElementVNode("button", {
                  type: "button",
                  onClick: closeDialog,
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})